/**
 * ajax工具类，已注入到Vue中，可通过Vue.ajax或者Vue实例的.$ajax调用
 * @module utils/ajax
 */

import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import cacheJsonp from './cacheJsonp';

const qs = require('qs');
Vue.use(VueAxios, axios)

// Add a request interceptor
Vue.axios.interceptors.request.use(function (config) {
  return config;
}, function (error) {
  // Do something with request error
  console.log('interceptors request error');
  return Promise.reject(error);
});

// Add a response interceptor
Vue.axios.interceptors.response.use(function (response) {
  if (response.status === 401) {
    // location.href = 'http://login.kf315.net/?callback=http://localhost:8000';
    return;
  }
  return response
}, function (error) {
  // Do something with response error
  console.log('interceptors response error');
  return Promise.reject(error);
});
let jsonpCallbackName = 0;
export const ajax = {
  get: function (url, params = {}, options = {}) {
    options['params'] = params;
    return Vue.axios.get(url, options).then((response) => {
      return response.data
    }).catch((error) => {
      return error
    });
  },
  jsonp: function (url, params = {}, options = {}) {
    return new Promise(function (resolve, reject) {
      params['callback'] = 'axiosJsonpCallbackName' + jsonpCallbackName++;
      window[params['callback']] = function (data) {
        delete window[params['callback']];
        const script = document.getElementById('scriptId' + params['callback']);
        script.parentNode.removeChild(script);
        resolve(data);
      }
      options['params'] = params;
      if (!params.n) {
        params.n = Math.round(Math.random() * 1000000);
      }
      const urlParams = qs.stringify(params);

      const script = document.createElement('script');
      if (url.indexOf('?') > -1) {
        url += '&' + urlParams;
      } else {
        url += '?' + urlParams;
      }
      script.setAttribute('id', 'scriptId' + params['callback']);
      script.setAttribute('src', url);
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    });
  }
};

ajax.cacheJsonp = cacheJsonp(ajax);

export default {
  install() {
    Vue.prototype.$ajax = ajax;
    Vue.ajax = ajax;
  }
}



// WEBPACK FOOTER //
// ./src/utils/ajax.js